import { render } from "./truck-icon.vue.js?vue&type=template&id=c9b41c60!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./truck-icon.vue?vue&type=template&id=c9b41c60"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__